import React, { useState } from "react";
import { HashScroll } from "@logora/debate.tools.hash_scroll";
import { MemberBox } from "@logora/parliament.parliament_member.member_box";
import sanitizeHtml from "sanitize-html";
import styles from "./InterventionBox.module.scss";
import cx from "classnames";
import { ComponentProps } from "react";

interface InterventionBoxProps {
  /** Intervention object */
  intervention: any;
  memberProps?: Omit<
    ComponentProps<typeof MemberBox>,
    "firstName" | "lastName" | "imageUrl" | "parliamentGroup"
  >;
}

export const InterventionBox = ({
  intervention,
  memberProps,
}: InterventionBoxProps) => {
  const [highlighted, setHighlighted] = useState(false);
  const containerId = `intervention_${intervention.ordreAbsoluSeance}`;

  const sanitize = (html: string): any => {
    const sanitizeOptions = {
      allowedTags: ["i", "sup", "br"],
    };

    let finalHtml = html.replace("<italique>", "<i>");
    finalHtml = finalHtml.replace("</italique>", "</i>");
    finalHtml = finalHtml.replace("<exposant>", "<sup>");
    finalHtml = finalHtml.replace("</exposant>", "</sup>");
    const sanitizedHtml = sanitizeHtml(finalHtml, sanitizeOptions);

    return { __html: sanitizedHtml };
  };

  return (
    <HashScroll elementId={containerId} onScroll={() => setHighlighted(true)}>
      <div
        id={containerId}
        className={cx(styles.container, { [styles.highlighted]: highlighted })}
      >
        {intervention.acteurRef && (
          <div className={styles.author}>
            <MemberBox
              firstName={intervention.acteurRef.prenom}
              lastName={intervention.acteurRef.nom}
              imageUrl={intervention.acteurRef.urlImage}
              {...(intervention.acteurRef?.groupeParlementaire
                ? {
                    parliamentGroup: {
                      groupName:
                        intervention.acteurRef?.groupeParlementaire?.libelle,
                      color:
                        intervention.acteurRef?.groupeParlementaire
                          ?.couleurAssociee,
                    },
                  }
                : {})}
              {...memberProps}
            />
          </div>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={sanitize(intervention.texte)}
        />
      </div>
    </HashScroll>
  );
};
